import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { ChatAdminActions } from './chat-admin.actions';
import { ChatAdminEffects } from './chat-admin.effects';
import { EscalationType } from '../../types/enum';

export const initialState: Readonly<ChatAdminState> = {
  isVa: false,
  escalationType: EscalationType.None,
  contextName: '',
  directEscalation: {},
  alertConfig: {},
};

export const chatAdminFeature = createFeature({
  name: 'chatAdmin',
  reducer: createReducer(
    initialState,
    on(ChatAdminActions.updateResponse, (state, { value }) => {
      return {
        ...state,
        isVa: value.isVa,
        escalationType: value.escalationType,
        contextName: value.contextName,
        directEscalation: value.directEscalation,
        alertConfig: value.alertConfig,
      };
    })
  ),
});

export const { selectChatAdminState, selectContextName } = chatAdminFeature;

export function provideChatAdminFeature() {
  return makeEnvironmentProviders([
    provideState(chatAdminFeature),
    provideEffects(ChatAdminEffects),
  ]);
}
